/**
 * Credito/licenza derivato dall'URL immagine.
 * Wikimedia Commons → link alla pagina File: (autore/licenza sulla pagina file).
 * Asset 6amico (/images, /hero, /api/uploads, /img) → "Archivio 6amico".
 */
export function creditFromSrc(src) {
  const s = String(src || "");
  const m = s.match(/commons\.wikimedia\.org\/(?:wiki\/)?Special:FilePath\/([^?#]+)/i);
  if (m) {
    let file = "";
    try {
      file = decodeURIComponent(m[1]);
    } catch {
      file = m[1];
    }
    return {
      label: "Wikimedia Commons",
      href: `https://commons.wikimedia.org/wiki/File:${encodeURIComponent(file)}`,
    };
  }
  if (/\/(images|hero|api\/uploads|img)\//i.test(s)) return { label: "Archivio 6amico", href: "" };
  return null;
}
